<template>
	<div
		class="channel-container"
		:class="open && 'active'"
		:style="{ marginBottom }"
	>
		<div
			class="channel-card"
			:class="[big && 'big', clickableChannel && 'clickable', useSmallTile(tile.type) && 'small']"
			@click="$emit('tileClicked')"
		>
			<span
				v-if="tile.channelPackage"
				class="package"
				>Pakke</span
			>
			<img
				:class="tile.channelPackage || (tile.points && 'has-bars')"
				:src="tile.logo.src"
				:alt="tile.name"
				v-if="tile.logo"
			/>
			<span
				v-if="tile.points"
				class="points"
				>{{ tile.points }} poeng</span
			>
		</div>
		<span
			class="channel-name"
			v-if="!hideName"
			>{{ tile.name }}</span
		>

		<!-- Tile dropdown -->
		<div
			class="channel-card-info"
			:class="[whiteBg && 'bg-white']"
			ref="info"
		>
			<div class="tv-content-container">
				<div
					class="content left"
					:class="[noImage && 'no-image', imageLeft && 'switch-side']"
				>
					<h2>{{ tile.name }}</h2>
					<div
						class="features"
						v-if="tile.feature"
					>
						<div
							v-for="(feature, idx) in tile.feature"
							:key="idx"
							:class="featureWrapClass(feature)"
						>
							<span :class="featureClass(feature)"></span><span>{{ feature }}</span>
						</div>
						<div
							class="feature greyed"
							v-for="(missingFeature, idx) in tile.missingFeature"
							:key="idx"
						>
							<span class="uncheck"></span><span>{{ missingFeature }}</span>
						</div>
					</div>
					<div
						class="features"
						v-else-if="tile.missingFeature"
					>
						<div
							class="feature"
							v-for="(missingFeature, idx) in tile.missingFeature"
							:key="idx"
						>
							<span class="un-check"></span><span>{{ missingFeature }}</span>
						</div>
					</div>
					<LazyRichText
						v-if="tile.description"
						:text="tile.description"
					></LazyRichText>
					<div
						v-if="tile.channelPackage && tile.bundle"
						class="channels-in-package"
					>
						<span class="package-heading">Pakken inneholder:</span>
						<ul class="bundle">
							<li
								v-for="(bundle, idx) in tile.bundle"
								:key="idx"
								class="bundle-channel"
							>
								<span class="channel-name">{{ bundle.name }}</span>
								<span
									v-if="bundle.position"
									class="channel-position"
									>Kanalplass: {{ bundle.position }}</span
								>
							</li>
						</ul>
					</div>
					<LazyLinkInline
						v-if="bottomLink"
						v-bind="bottomLink"
					></LazyLinkInline>
					<div class="additional-info">
						<span v-if="tile.language">{{ tile.language }}</span>
						<span v-if="tile.position">{{ tile.position }}</span>
					</div>
				</div>
				<div
					class="content right"
					:class="[imageLeft && 'switch-side']"
				>
					<div
						class="image-container"
						:class="noImage && 'hidden'"
					>
						<img
							class="infobox-logo"
							:src="tile.logo && tile.logo.src"
							:alt="tile.name"
							:style="imageWidth && { width: imageWidth + 'px' }"
						/>
					</div>
				</div>
				<a
					href="javascript:"
					:title="'Close the ' + tile.name + ' channel info'"
					class="close-button"
					@click="$emit('tileClicked')"
				></a>
			</div>
		</div>
	</div>
</template>

<script>
export default defineNuxtComponent({
	name: "TvChannelTile",
	props: ["big", "hide-name", "tile", "checked", "open", "image-left"],

	data() {
		return {
			marginBottom: null,
			array: ["hei", "hallo", "heihei"],
		};
	},

	computed: {
		info() {
			return this.tile.info;
		},
		imageWidth() {
			return this.tile.imageWidth;
		},
		image() {
			return this.tile.image;
		},
		noImage() {
			return this.tile.noImage;
		},
		whiteBg() {
			return this.tile.whiteBg;
		},
		clickableChannel() {
			return this.tile.feature && this.tile.feature.length > 0;
		},

		bottomLink() {
			if (this.tile.bottomLink) {
				return {
					href: this.tile.bottomLink.externalLink,
					text: this.tile.bottomLink.linkText,
				};
			} else {
				return null;
			}
		},
	},

	methods: {
		setMarginBottom(open) {
			if (open) {
				this.marginBottom = this.$refs.info && this.$refs.info.clientHeight + 71 + "px";
			} else {
				this.marginBottom = null;
			}
		},
		useSmallTile(type) {
			return type === "fixed-channel" || type === "optional-channel";
		},
		featureWrapClass(feature) {
			if (this.featureClass(feature) === "check") return "feature";
			else return "feature-w-icon";
		},
		featureClass(feature) {
			switch (feature) {
				case "Start Forfra":
					return "startOver";
				case "Ukesarkiv":
					return "weeklyArchive";
				case "Tilgang i T-We app":
					return "availableApp";
				case "TV-arkiv":
					return "streamingService";
				default:
					return "check";
			}
		},
	},
});
</script>

<style lang="scss" scoped>
.channel-container {
	text-align: center;
	display: inline-block;
	vertical-align: top;
	transition: margin-bottom 0.25s ease-out;
	overflow: hidden;
	cursor: pointer;

	/* CHANNEL CARD */

	/* CHANNEL INFO BOX */

	margin: $spacing-s;

	.channel-name {
		display: block;

		@include font-text-m;
	}

	.channel-card {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #dbdbdb;
		width: 128px;
		height: 128px;
		z-index: 3;
		margin: $spacing-s;

		&.clickable {
			cursor: pointer;
		}

		img {
			max-width: 80%;
			max-height: 50%;
			flex: 0 0 auto;
		}

		.package,
		.points {
			position: absolute;
			width: 100%;
			padding: 2px;
			background-color: $color-neutrals-25-tint;

			@include font-text-xs;
		}

		.package {
			top: 0;
		}

		.points {
			bottom: 0;
		}

		&.big {
			width: 190px;
			min-height: 190px;
			margin: $spacing-xl $spacing-xs $spacing-xs $spacing-xs;
		}

		&.small {
			width: 95px;
			height: 88px;

			img.has-bars {
				position: absolute;
				top: 30%;
				transform: translateY(-30%);
				max-height: 40px;

				@include breakpoint(mobile) {
					top: auto;
					transform: none;
				}
			}
		}
	}

	&.active {
		.channel-card-info {
			opacity: 1;
			transition: opacity 0.5s ease-out;
			z-index: 2;
		}

		.channel-name {
			font-weight: bold;
		}

		.channel-card {
			border: 1px solid transparent;
			box-shadow: 0 0 0 2px #19aaf8;
		}
	}

	.channel-card-info {
		background: #f1f2f3;
		display: flex;
		position: absolute;
		left: 0;
		width: 100%;
		margin-top: $spacing-xl;
		z-index: -1;
		opacity: 0;
		overflow: hidden;
		transition: opacity 0.25s;

		.channels-in-package {
			margin-top: $spacing-l;

			.package-heading {
				font-weight: bold;
			}
		}

		.bundle {
			margin-top: $spacing-m;

			&-channel {
				display: inline-flex;
				flex-flow: row nowrap;
				justify-content: space-between;
				width: 100%;
				margin: $spacing-s 0;

				span {
					display: inline-block;
					font-family: $font-family-telenor-ui;
				}
			}
		}

		.tv-content-container {
			width: 100%;
			position: relative;
			margin: 0 auto;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: $spacing-l;
			color: #222;
			font-family: $font-family-telenor-ui;

			.feature,
			.feature-w-icon,
			.additional-info {
				margin-bottom: $spacing-m;
			}

			.feature-w-icon {
				display: inline-flex;
				align-items: center;
				margin-right: $spacing-m;

				.startOver,
				.weeklyArchive,
				.availableApp,
				.streamingService {
					display: inline-block;
					height: $spacing-l;
					padding-left: $spacing-l;
					margin-right: $spacing-s;
					background-repeat: no-repeat;
					background-size: contain;
				}

				.startOver {
					background-image: url("https://telenor.no/binaries/frontend/restart_bg_white.svg");
				}

				.weeklyArchive {
					background-image: url("https://telenor.no/binaries/frontend/weekly_archive_bg_white.svg");
				}

				.availableApp {
					background-image: url("https://telenor.no/binaries/frontend/phone_bg_white.svg");
				}

				.streamingService {
					background-image: url("https://telenor.no/binaries/frontend/tv_outline_bg_white.svg");
				}
			}
		}

		@include breakpoint(mobile) {
			padding: $spacing-l $spacing-2xl;
		}
	}

	.channel-card-tile.bg-white {
		background: #fff;
	}
}

.channel-container .channel-card-info .tv-content-container .content {
	text-align: left;
}

.channel-container .channel-card-info .tv-content-container .content table tr {
	background-color: transparent;
}

.channel-container .channel-card-info .tv-content-container .content.left {
	width: 50%;
	margin: 0 10% 0 0;

	&.switch-side {
		order: 2;
	}
}

.channel-container .channel-card-info .tv-content-container .content.left.no-image {
	width: 100%;
	margin: 0;
}

.channel-container .channel-card-info .tv-content-container .content.left.no-image ~ .right {
	display: none;
}

.channel-container .channel-card-info .tv-content-container .content.right {
	width: 30%;
	margin: 0 5%;

	&.switch-side {
		order: 1;
	}
}

.channel-container .channel-card-info .tv-content-container .content.right .image-container {
	text-align: center;
}

.channel-container .channel-card-info .tv-content-container .content h2 {
	text-align: left;
	margin-bottom: $spacing-l;
	margin-top: $spacing-s;
}

.channel-container .channel-card-info .tv-content-container .content .text-normal {
	margin-top: $spacing-xl;
	margin-bottom: $spacing-xl;
}

.channel-container .channel-card-info .tv-content-container .content .features,
.channel-container .channel-card-info .tv-content-container .content .additional-info {
	margin-top: $spacing-m;

	@include font-text-xs;
}

.channel-container .channel-card-info .tv-content-container .content .features .feature,
.channel-container .channel-card-info .tv-content-container .content .additional-info .feature {
	display: inline-block;
	margin-right: $spacing-s;
}

.channel-container .channel-card-info .tv-content-container .content .features .feature .check,
.channel-container .channel-card-info .tv-content-container .content .additional-info .feature .check {
	margin-right: $spacing-xs;
	width: 12px;
	height: $spacing-s;
	display: inline-block;
	text-align: left;
	position: relative;
	top: -3px;
	border: 0 solid #6b7073;
	border-bottom-width: 1px;
	border-left-width: 1px;
	transform: rotate(-48deg);
}

.channel-container .channel-card-info .tv-content-container .content .features .feature .uncheck,
.channel-container .channel-card-info .tv-content-container .content .additional-info .feature .uncheck {
	margin-right: $spacing-xs;
	display: inline-block;
	position: relative;
	width: $spacing-s;
	height: $spacing-s;
	transform: rotate(-45deg);
}

.channel-container .channel-card-info .tv-content-container .content .features .feature .uncheck::after,
.channel-container .channel-card-info .tv-content-container .content .additional-info .feature .uncheck::after {
	width: $spacing-s;
	height: 5.33px;
	border-bottom: 1px solid #afafb0;
	display: block;
	position: absolute;
	content: " ";
}

.channel-container .channel-card-info .tv-content-container .content .features .feature .uncheck::before,
.channel-container .channel-card-info .tv-content-container .content .additional-info .feature .uncheck::before {
	width: 5.16px;
	height: $spacing-s;
	border-right: 1px solid #afafb0;
	display: block;
	position: absolute;
	content: " ";
}

.channel-container .channel-card-info .tv-content-container .content .features .greyed,
.channel-container .channel-card-info .tv-content-container .content .additional-info .greyed {
	font-style: italic;
	color: #afafb0;
}

.channel-container .channel-card-info .tv-content-container .content .additional-info span {
	margin-right: $spacing-2xl;
}

.channel-container .channel-card-info .tv-content-container .content .additional-info span:last-child {
	margin-right: 0;
}

.channel-container .channel-card-info .tv-content-container .content .infobox-logo {
	width: 100%;
}

.channel-container .channel-card-info .tv-content-container .content .button-cta {
	background: inherit;
}

.channel-container .channel-card-info .close-button {
	background: url("https://www.telenor.no/binaries/frontend/overlay-exit.svg");
	background-repeat: no-repeat;
	background-size: contain;
	width: $spacing-l;
	height: $spacing-l;
	position: absolute;
	top: $spacing-l;
	right: $spacing-l;
} // Compiled to CSS from the original LESS file

@media (width <= 480px) {
	.channel-container .channel-card-info .tv-content-container {
		padding: $spacing-s;
		flex-direction: column;
		justify-content: space-around;
	}
}

@media (width <= 480px) {
	.channel-container .channel-card-info .tv-content-container .content {
		width: 100%;
		margin: 0;
	}

	.channel-container .channel-card-info .tv-content-container .content .text-normal {
		max-width: 100%;
	}
}

@include breakpoint(mobile) {
	.channel-container .channel-card,
	.channel-container .channel-card.big {
		width: 128px;
		height: 128px;
		min-height: 128px;
		margin: $spacing-xl $spacing-s $spacing-xs $spacing-s;
	}

	.channel-container .channel-card .channel-name,
	.channel-container .channel-card.big .channel-name {
		width: 128px;
		margin: 0 auto;
	}
}

@include breakpoint(mobile) {
	.channel-container .channel-card-info .tv-content-container .content.right {
		display: none;
	}

	.channel-container .channel-card-info .tv-content-container .content.left {
		width: 90%;
		margin: 0 5%;
	}
}
</style>
